import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Header from "./components/header/Header";
import Home from "./pages/home/Home";
import Services from "./pages/Services/Services";
import Footer from "./components/Footer/Footer";
import Fleet from "./pages/Fleet/Fleet";
import Details from "./pages/Details/Details";
import Book from "./pages/Book/Book";

import About from "./pages/About/About";
import FAQ from "./pages/FAQ/FAQ";
import Terms from "./pages/Terms/Terms";
import Contact from "./pages/Contact/Contact";

function App() {
  // console.log(log);

  return (
    <div className="App">
      <Header />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/details" element={<Details />} />
        <Route path="/book" element={<Book />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
